// export interface customerType {
//   customerTypeId: string
//   customerTypeName: string
// }

export interface ICustomerInfo {
  customerDetailsType: 'Commercial Customer' | 'Enroll Existing User'
  companyName: string
  customerType: string
  customerFirstName: string
  customerLastName: string
  customerEmailId: string
  customerPhoneNumber: number
  serviceAddress: string
  serviceAddress2: string
  serviceCountry: string
  serviceState: string
  serviceCity: string
  serviceZipCode: string
  billingAddressCheckbox: string
  billingAddress: string
  billingAddress2: string
  billingCountry: string
  billingState: string
  billingCity: string
  billingZipCode: string
  unitNumber: string
  documentDelivery: string
  setDocumentDelivery: any
}

export interface IProductInfo {
  commodity: string
  utility: string
  contractType: string
  tpvLanguage: string
  brand: string
  productName: string
  utilityAccountNumber: string
  gutilityAccountNumber: string
}

export interface IAgentEnrollmentData {
  customerInfo: ICustomerInfo
  productInfo: IProductInfo
}

export const defaultAgentEnrollment = {
  businessName: '',
  customerType: '',
  customerTypeId: '',
  customerFirstName: '',
  customerLastName: '',
  customerEmailId: '',
  customerPhoneNumber: '',
  customerPrimaryPhoneNumber: '',
  serviceAddress: '',
  serviceAddress2: '',
  serviceCountry: 'US',
  serviceState: '',
  serviceCity: '',
  serviceZipCode: '',
  billingAddressCheckbox: '',
  billingAddress: '',
  billingAddress2: '',
  billingCountry: 'US',
  billingState: '',
  billingCity: '',
  billingZipCode: '',
  utilityAccountNumber: '',
  utilityAccountNumberId: '',
  gutilityAccountNumber: '',
  gutilityAccountNumberId: '',
  languageId: '',
  productName: '',
  electricMixMatchProductId: '',
  gasMixMatchProductId: '',
  isMixMatch: false,
  id: '',
  documentDelivery: 'MAIL',
  pincode: '',
  commodity: '',
  commodityId: '',
  selectedProductCommodity: '',
  customerBillUrl: [],
  tpvType: '',
  address: '',
  tpvId: null,
}

export const fieldTouched = (status: boolean) => {
  return {
    businessName: status,
    customerType: status,
    customerTypeId: status,
    customerFirstName: status,
    customerLastName: status,
    customerEmailId: status,
    customerPhoneNumber: status,
    customerPrimaryPhoneNumber: status,
    serviceAddress: status,
    serviceAddress2: status,
    serviceCountry: status,
    serviceState: status,
    serviceCity: status,
    serviceZipCode: status,
    billingAddressCheckbox: status,
    billingAddress: status,
    billingAddress2: status,
    billingCountry: status,
    billingState: status,
    billingCity: status,
    billingZipCode: status,
    utilityAccountNumber: status,
    languageId: status,
    productName: status,
    id: status,
    documentDelivery: status,
    pincode: status,
  }
}

export type StepProps = {
  data: IAgentEnrollmentData
  updateData: (fieldsToUpdate: Partial<IAgentEnrollmentData>) => void
  hasError: boolean
  formik: any
  hasFieldError: boolean
  method: any
  getProductInfo: any
  products: any
  show: boolean
  validationSchema: any
  setValidationSchema: any
  Yup: any
  productDetails: any
  setProductDetails: any
  UANValidation: any
  tpvMethods: any
  isOptedIn: boolean
  sendContract: any
  sendContractEmail: any
  isMixmatch: boolean
  triggerOptinAlert: () => void
  checkExistingCustomerForSymmetry: any
  checkExistingCustomerFromAPI: boolean
  checkPhonenumberOptin: any
  getProductLanguage: any
  languages: any
}

export type StepCustomerProps = {
  data: IAgentEnrollmentData
  updateData: (fieldsToUpdate: Partial<IAgentEnrollmentData>) => void
  hasError: boolean
  formik: any
  hasFieldError: boolean
  isCommercialCustomer: any
  setIsCommercialCustomer: any
  isExistingCustomer: any
  SetIsExistingCustomer: any
  defaultAgentEnrollment: any
  mode: any
  UANValidation: any
  validateNumber: any
  searchText: any
  setSearchText: any
  setCustomer: any
  customer: any
  getCustomerByPhoneNumber: any
  customerLoading: any
  customerData: any
  isServiceSameAsBill: any
  setIsServiceSameAsBill: any
  bussinessRef: any
  getcustomerByIdData: any
  featureFlags: any
  setSendContract: any
  sendContract: boolean
  setSendContractEmail: any
  sendContractEmail: boolean
  customerFeatureFlags: any
  isOptedIn: boolean
  triggerOptinAlert: () => void
  setDocumentDelivery: any
}

// Need to set these when we click on edit
export const editAgentEnrollment = {
  businessName: '',
  customerType: '',
  customerFirstName: '',
  customerLastName: '',
  customerEmailId: '',
  customerPhoneNumber: '',
  serviceAddress: '',
  serviceAddress2: '',
  serviceCountry: 'US',
  serviceState: 'Alabama',
  serviceCity: '',
  serviceZipCode: '',
  billingAddressCheckbox: '',
  billingAddress: '',
  billingAddress2: '',
  billingCountry: 'US',
  billingState: 'Alabama',
  billingCity: '',
  billingZipCode: '',
  utilityAccountNumber: '',
  languageid: '',
  productName: '',
  id: '',
  documentDelivery: '',
  pincode: '',
  customerBillUrl: [],
  tpvType: '',
  sendContract: false,
}
